var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { AfterContentInit, EventEmitter } from '@angular/core';
import { MatMenu, MatMenuTrigger } from '@angular/material/menu';
import { PlaceType } from '../../../../components/hub/place.category/customize.place.category.component';
import { VisitorDataCache } from '../../../../stores/visitor.calendar.store';
var NestedMenuItemComponent = /** @class */ (function () {
    function NestedMenuItemComponent() {
        // need to update this to support any level nested
        this.maxLevels = 3;
        this.item = null;
        this.useNonLeafMenuClick = false;
        this.onClick = new EventEmitter();
        this.onNonLeafClick = new EventEmitter();
    }
    NestedMenuItemComponent.prototype.ngAfterContentInit = function () {
        var _this = this;
        /**
         * first time the page loads this works fine, but not for view changed. So add the menus to cache in the closeOther function
         * */
        setTimeout(function () {
            _this.trigger && VisitorDataCache.addCustomDefaultPlaceCategoryMatMenus(_this.trigger, _this.item.level);
        });
    };
    Object.defineProperty(NestedMenuItemComponent.prototype, "subMenu", {
        set: function (value) {
            this.item.subMenuEleRef = value;
        },
        enumerable: true,
        configurable: true
    });
    NestedMenuItemComponent.prototype.select = function (item) {
        if (item === 'All') {
            this.onClick.emit(this.item);
        }
        else {
            this.onClick.emit(item);
        }
    };
    NestedMenuItemComponent.prototype.closeOther = function (trigger) {
        /**
         * this works for the first time the page loads, but if you redirect to map view and get back to the calendar, the menus are not in control
         * */
        for (var _i = 0, _a = VisitorDataCache.customDefaultPlaceCategoryMatMenus; _i < _a.length; _i++) {
            var menu = _a[_i];
            if (this.item.level === 0)
                menu.trigger.closeMenu();
            if (this.item.level > 0 && menu.level > 0) {
                // mouse enter the leaf level menu don't close itself
                if (this.item.level !== this.maxLevels - 1)
                    menu.trigger.closeMenu();
            }
        }
        /**
         * the following function manually control the open and hide of the menus
         * */
        trigger && VisitorDataCache.addCustomDefaultPlaceCategoryMatMenus(trigger, this.item.level);
        trigger && trigger.openMenu();
    };
    NestedMenuItemComponent.prototype.menuOpened = function () {
        setTimeout(function () {
            var menus = document.querySelectorAll('.mat-menu-panel');
            var button = document.querySelector('#filter-place-category');
            var width = button.getBoundingClientRect().width + "px";
            Array.from(menus).forEach(function (menu, index) {
                menu.style.width = width;
                menu.style.maxWidth = width;
            });
        });
    };
    NestedMenuItemComponent.prototype.midMenuClick = function (item, trigger) {
        if (this.useNonLeafMenuClick) {
            this.onNonLeafClick.emit(item);
            trigger && trigger.closeMenu();
        }
    };
    return NestedMenuItemComponent;
}());
export { NestedMenuItemComponent };
var PlaceTypeForMenu = /** @class */ (function (_super) {
    __extends(PlaceTypeForMenu, _super);
    function PlaceTypeForMenu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return PlaceTypeForMenu;
}(PlaceType));
export { PlaceTypeForMenu };



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/nested.menu/nested.menu.item/nested.menu.item.component.ts.pre-build-optimizer.js